import { api } from './index';
import { ApiResponse, DashboardStatus, CostOverviewResponse } from '../types';

// Robustes Parsing des Dateinamens aus dem Content-Disposition Header
function extractFilenameFromContentDisposition(disposition: string | undefined, fallback: string): string {
  if (!disposition) return fallback;

  try {
    // Bevorzugt RFC 5987/6266: filename*=utf-8''...
    const starMatch = disposition.match(/filename\*\s*=\s*([^;]+)/i);
    if (starMatch && starMatch[1]) {
      let value = starMatch[1].trim();
      // Quotes entfernen
      if (value.startsWith('"') && value.endsWith('"')) value = value.slice(1, -1);
      // Format: utf-8''ENCODED_NAME oder UTF-8''...
      const parts = value.split("''");
      const encoded = parts.length === 2 ? parts[1] : value;
      try {
        return decodeURIComponent(encoded);
      } catch {
        return encoded;
      }
    }

    // Fallback: klassisches filename="..."
    const simpleMatch = disposition.match(/filename\s*=\s*([^;]+)/i);
    if (simpleMatch && simpleMatch[1]) {
      let value = simpleMatch[1].trim();
      if (value.startsWith('"') && value.endsWith('"')) value = value.slice(1, -1);
      try {
        // Falls der Server doch Prozent-Kodierung im filename nutzt
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    }
  } catch {
    // ignore parsing errors and use fallback
  }

  return fallback;
}

export const dashboardService = {
  getDashboardStatus: async (): Promise<DashboardStatus> => {
    const response = await api.get<ApiResponse<DashboardStatus>>('/dashboard/status');
    return response.data.data;
  },

  downloadDashboardExcel: async (): Promise<Blob> => {
    const response = await api.get('/dashboard/download', {
      responseType: 'blob',
      headers: { 'Accept': 'application/vnd.ms-excel.sheet.macroEnabled.12' }
    });
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Gesamt_Dashboard_${new Date().toISOString().slice(0, 10)}.xlsm`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    return blob;
  },

  getCostOverview: async (filters?: { zeitraum?: string; dienstleister?: string; vonDatum?: string; bisDatum?: string; }): Promise<CostOverviewResponse> => {
    const params = new URLSearchParams();
    if (filters?.zeitraum) params.append('zeitraum', filters.zeitraum);
    if (filters?.dienstleister) params.append('dienstleister', filters.dienstleister);
    if (filters?.vonDatum) params.append('vonDatum', filters.vonDatum);
    if (filters?.bisDatum) params.append('bisDatum', filters.bisDatum);
    const response = await api.get<ApiResponse<CostOverviewResponse>>(`/dashboard/cost-overview?${params.toString()}`);
    return response.data.data;
  },

  downloadAnalysis: async (analysisId: string): Promise<Blob> => {
    const response = await api.get(`/dashboard/cost-overview/${analysisId}/download`, {
      responseType: 'blob', headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
    });
    const blob = response.data;
    const disposition: string | undefined = response.headers['content-disposition'];
    console.log(disposition);
    const filename = extractFilenameFromContentDisposition(disposition, `Analyseergebnisse_${analysisId}.xlsx`);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    return blob;
  },

  downloadAddendum: async (analysisId: string): Promise<Blob> => {
    const response = await api.get(`/dashboard/cost-overview/${analysisId}/addendum/download`, {
      responseType: 'blob', headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }
    });
    const blob = response.data;
    const disposition: string | undefined = response.headers['content-disposition'];
    const filename = extractFilenameFromContentDisposition(disposition, `Ergaenzungsvereinbarung_${analysisId}.docx`);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    return blob;
  },

  downloadBulkAnalyses: async (analysisIds: string[]): Promise<Blob> => {
    const response = await api.post('/dashboard/cost-overview/zip-download', { analysis_ids: analysisIds }, {
      responseType: 'blob', headers: { 'Accept': 'application/zip' }
    });
    const blob = response.data;
    const disposition: string | undefined = response.headers['content-disposition'];
    const filename = extractFilenameFromContentDisposition(
      disposition,
      `DORA_Analysen_Bulk_${new Date().toISOString().slice(0, 10)}.zip`
    );
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    return blob;
  }
};



